import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import IngredientDictionary from "@/pages/IngredientDictionary";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/ingredients" element={<IngredientDictionary />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
